var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Photo',{attrs:{"currentConstruction":_vm.currentConstruction,"suggestWords":_vm.suggestWords}})}
var staticRenderFns = []

export { render, staticRenderFns }